// This file was auto-generated by Fern from our API Definition.
export const ChannelPolicyLevel = {
    Capability: "capability",
    Channel: "channel",
    Agent: "agent",
    Space: "space",
    Grant: "grant",
};
